// removed by extract-text-webpack-plugin
module.exports = {"container":"QEBAyrYnmgseOxHY","container--scale":"q5XGKNmfgaeiSjZQ","container--scale_over":"_3R39iaL0Cw-T-F2v","container--always_opened":"_3JcQdWrBTtWTlU0_","container--no_shadow":"VtVQ4YnI58SA3tJ1","list":"_3njfj2ZwsHu6gfq6","item":"HQtt_F6F02NMZvrL","link":"_1HtR19DTeV_PyjHh","domrf-promo":"_-iAWcauWNmqD4rXq"};


//////////////////
// WEBPACK FOOTER
// ./src/bundles/header/components/dropdown_menu/dropdown_menu.css
// module id = 419
// module chunks = 5